import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './app/App';
import { APP_CONFIG, STORAGE_KEYS } from './config/app.config';
import { applyBrandCssVariables } from './theme/brandColors';
import './styles/index.css';

const initialTheme = () => {
  const stored = window.localStorage.getItem(STORAGE_KEYS.THEME);
  if (stored === 'light' || stored === 'dark') return stored;
  if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) return 'dark';
  return APP_CONFIG.defaultTheme;
};

const bootTheme = initialTheme();
document.documentElement.setAttribute('data-theme', bootTheme);
applyBrandCssVariables(bootTheme);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
